export default __webpack_public_path__ + "static/xbox-06e9a1ed76c7e6ddec693c3960f65bed.jpg";